/**
 * A simple central location for debugging configurations.
 */
export class DebugConfig {
    static loggingEnabled: boolean = false;
}
